








import { defineComponent, ref } from "@vue/composition-api";
import { PersonalInformation } from "@scrile/api-provider/dist/api/PersonalInformationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import { personalInfoFields } from "../config";

export default defineComponent({
  name: "PersonalInfoForm",
  components: { BaseForm },
  setup(_, { emit }) {
    const { authUserStrict } = useAuthUser();
    const personalInformation = ref<PersonalInformation | null>(null);
    const values = ref<FormValues>({
      firstName: "",
      lastName: "",
      phone: "",
    });

    const getData = async () => {
      personalInformation.value = await providers.PersonalInformationProvider.find({ id: authUserStrict.value.id });
      values.value = {
        firstName: personalInformation.value.firstName,
        lastName: personalInformation.value.lastName,
        phone: personalInformation.value.phone,
      };
    };

    const submitPersonalInfo = async () => {
      const data = {
        userId: authUserStrict.value.id,
        phone: values.value.phone,
      };
      personalInformation.value = await providers.PersonalInformationProvider.update({ data });
      values.value = {
        ...values.value,
        firstName: personalInformation.value.firstName,
        lastName: personalInformation.value.lastName,
        phone: personalInformation.value.phone,
      };
    };

    const created = async () => {
      emit("setValid", true);
      emit("setCb", () => submitPersonalInfo());
      try {
        emit("setLoading", true);
        await getData();
      } finally {
        emit("setLoading", false);
      }
    };

    created();

    return {
      values,
      personalInfoFields,
    };
  },
});
